import queryString from "query-string";
import { axios } from "../lib";

import * as endpoints from "./apiEndpoints";

class CallService {
  static loadCalls(body) {
    let url = `${endpoints.BASE_URL}${endpoints.CALLS}`;
    if (body && typeof body.filtered !== "undefined") {
      return axios.post(url, body).then((response) => response.data);
    }

    if (body) {
      const params = queryString.stringify(body);
      url = url.concat(`?${params}`);
    }

    return axios.get(url).then((response) => response.data);
  }

  static loadProjectBreakdownCalls(body) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/project-breakdown`;
    return axios.post(url, body).then((response) => response.data);
  }

  static loadCallsByProjectId(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/project/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static loadCallsByUserId(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/user/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static loadCallsByStageId(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/stage/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static getCall(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/${id}`;

    return axios.get(url).then((response) => response.data);
  }

  static createCall(call) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/new`;
    const body = {
      call
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateCall(call) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/${call._id}`;
    const body = {
      call
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static async batchLoadCalls(body) {
    // delete body.created_by;
    let url = `${endpoints.BASE_URL}${endpoints.CALLS}/batch`;
    const params = `&${queryString.stringify(body, {
      arrayFormat: "bracket"
    })}`;
    url = url.concat(`?${params}`);
    return axios.get(url).then((response) => response.data);
  }

  static deleteCall(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/${id}`;
    return axios.delete(url).then((response) => response.data);
  }

  static updateInvoicedCall(call) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/${call._id}/line`;

    const body = {
      call
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static getRecurringCalls(id) {
    const url = `${endpoints.BASE_URL}${endpoints.RECURRING_CALLS}/${id}`;

    return axios.get(url).then((response) => response.data);
  }

  static createRecurringCalls(calls, recurrence) {
    const url = `${endpoints.BASE_URL}${endpoints.RECURRING_CALLS}`;
    const body = {
      calls,
      recurrence
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateRecurringCalls(recurringId, data) {
    const url = `${endpoints.BASE_URL}${endpoints.RECURRING_CALLS}`;
    const body = {
      recurringId,
      data
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteRecurringCalls(id) {
    const url = `${endpoints.BASE_URL}${endpoints.RECURRING_CALLS}/${id}`;
    return axios.delete(url).then((response) => response.data);
  }

  static getRecurrence(id) {
    const url = `${endpoints.BASE_URL}${endpoints.RECURRENCE}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static bulkApprove(idArray, user, stageID) {
    const url = `${endpoints.BASE_URL}${endpoints.BULK_CALL_APPROVE}`;
    const body = {
      idArray,
      userID: user,
      stageID
    };
    return axios.post(url, body).then((response) => response.data);
  }

  static createPart(call, part) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/${call}/part`;
    const body = {
      part
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updatePart(call, part) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/${call}/part`;
    const body = {
      part
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deletePart(call, part) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/${call}/part/delete`;

    const body = {
      part
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static fetchTimePlannerCalls(params) {
    const query = new URLSearchParams();

    // eslint-disable-next-line no-restricted-syntax
    for (const k in params) {
      if (Array.isArray(params[k])) {
        query.append(k, params[k].join(","));
      } else {
        query.append(k, params[k]);
      }
    }

    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/timeplanner?${query}`;
    return axios.get(url).then((res) => res.data);
  }

  static fetchAggregateHours(params = {}) {
    const query = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        query.append(key, params[key]);
      }
    });
    const url = `${endpoints.BASE_URL}${
      endpoints.CALLS
    }/projects?${query.toString()}`;
    return axios.get(url).then((res) => res.data);
  }

  static fetchStatusAggregate(params = {}) {
    const query = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        query.append(key, params[key]);
      }
    });
    const url = `${endpoints.BASE_URL}${
      endpoints.CALLS
    }/status?${query.toString()}`;
    return axios.get(url).then((res) => res.data);
  }

  static createHoliday(call) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/new-holiday`;
    const body = {
      call
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static createIndividualHoliday(call, users) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/new-ind-holiday`;
    const body = {
      call,
      users
    };
    return axios.post(url, body).then((response) => response.data);
  }

  static updateManyCalls(calls) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/update-many`;
    const body = {
      calls
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static notifyCallApproval(id, message) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/${id}/notify/call-approval`;
    const body = {
      message
    };
    return axios.post(url, body).then((response) => response);
  }

  static getCallsForMigration(body) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/migrate-calls/get`;
    return axios.post(url, body).then((response) => response.data);
  }

  static migrateMultipleCalls(calls, user, filters) {
    const url = `${endpoints.BASE_URL}${endpoints.CALLS}/migrate-calls`;
    const body = {
      calls,
      user,
      filters
    };
    return axios.post(url, body).then((response) => response);
  }
}

export default CallService;
